export default {"src":"/_next/static/media/gbx.1f5b1441.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};